module.exports = __webpack_public_path__ + "img/document.c336dd5.svg";